import { RouteConfig } from 'vue-router';

import SearchPsychologistPage from '@/views/SearchPsychologistPage.vue';
import { RouteName } from '@/router/route-name';

const routes: RouteConfig[] = [
	// Page de recherche de psychologues
	{
		path: '/',
		redirect: '/recherche-psychologue'
	},
	{
		path: '/recherche-psychologue',
		name: RouteName.HOME,
		component: SearchPsychologistPage
	},
	// Page de contact
	{
		path: '/contact',
		name: RouteName.CONTACT,
		component: () => import(
			'@/views/ContactPage.vue'
			)
	},
	// Page des CGU
	{
		path: '/mentions-legales',
		name: window.URL_LEGAL_MENTION,
		component: () => import(
			'@/views/MentionsLegalesCGUPage.vue'
			)
	},
	{
		path: '/maintenance',
		name: RouteName.MAINTENANCE,
		component: () => import(
			'@/views/Maintenance.vue'
			)
	},
	// Page non trouvée
	{
		path: '*', // Everything that doesn't match a route
		name: RouteName.NOT_FOUND,
		component: () => import(
			'@/views/NotFound.vue'
			)
	}
];

export { routes };
